import axios from '@/api';
import authHeader from '@/services/auth-header';

const BASE_URL =
    process.env.VUE_APP_API_URL + "favorite";


class FavoriteApi {

    getGroups() {
        return axios.get(`${BASE_URL}/groups`,
            {
                headers: authHeader()
            }
        );
    }


    getItems(groupId) {

        return axios.get(`${BASE_URL}/groups/${groupId}`,
            {
                headers: authHeader()
            }
        );
    }


    createGroup(name) {
        return axios.post(`${BASE_URL}/groups`,
            {
                name
            },
            {
                headers: authHeader()
            }
        );
    }


    addFavorite(groupId, files) {
        return axios.post(`${BASE_URL}/groups/${groupId}/items`,
            {
                files
            },
            {
                headers: authHeader()
            }
        );
    }


    deleteItem(groupId, itemId, autoDelete = false) {
        return axios.delete(`${BASE_URL}/groups/${groupId}/items/${itemId}`,
            {
                headers: authHeader(),
                data: {
                    autoDelete
                }
            }
        );
    }

    async renameGroup(groupId, name) {
        const response = await axios.put(`${BASE_URL}/groups/${groupId}`,
            {
                name
            },
            {
                headers: authHeader()
            }
        );

        return response;
    }

    async deleteGroup(groupId) {
        const response = await axios.delete(`${BASE_URL}/groups/${groupId}`,
            {
                headers: authHeader()
            }
        );

        return response;
    }

    async reorderGroups(groups) {
        const response = await axios.put(`${BASE_URL}/groups/reorder`,
            {
                groups
            },
            {
                headers: authHeader()
            }
        );

        return response;
    }

    markFileMissing(itemId) {
        return axios.patch(
            `${BASE_URL}/items/${itemId}/file-status`,
            {
                fileExists: false
            },
            {
                headers: authHeader()
            }
        );
    }
}


export default new FavoriteApi();